import './navigation_form_controls_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  clearAll = (): void => {
    this.queryController.reset()

    this.filtersController.reset()

    for (const controller of this.choicesControllers) {
      controller.reset()
    }

    for (const controller of this.sliderControllers) {
      controller.reset()
    }
  }

  reset = (): void => {
    this.clearAll()
    setTimeout(() => this.navigationController.element.submit(), 250)
  }

  get navigationController (): object {
    return this.application.getControllerForElementAndIdentifier(this.element.closest('.navigation'), 'navigation')
  }

  get queryController (): object {
    return this.navigationController.queryController
  }

  get filtersController (): object {
    return this.navigationController.filtersController
  }

  get choicesControllers (): object[] {
    return this.navigationController.choicesControllers
  }

  get sliderControllers (): object[] {
    return this.navigationController.sliderControllers
  }

  submitForm = (event): void => {
    event.preventDefault()
    this.navigationController.submitForm()
  }
}
